import {
  ButtonComp,
  TextInputComp,
  MoneyInputComp,
  FormikSelectComp,
  CardComp,
} from "../../../../components";
import { Formik, Form } from "formik";
import { useCreateRegFeeMutation } from "../../../../store/admin/settings/regFeeSlice";
import { useGetFeeCategoriesQuery } from "../../../../store/selectableSlice";
import { toast } from "react-hot-toast";
import { FaTag, FaDollarSign, FaFileInvoiceDollar } from "react-icons/fa";

export default function NewRegistrationFee() {
  const [createRegFee] = useCreateRegFeeMutation();
  const { data: feeCategories = [], error: errorFeeCat, isLoading: isLoadingCategories } =
    useGetFeeCategoriesQuery();
  if (errorFeeCat) {
    console.log(errorFeeCat.data);
  }
  const addNewRegFee = async (formikValues, { resetForm }) => {
    const reqBody = {
      ...formikValues,
    };
    const toastId = toast.loading("Submitting");
    const { data, error } = await createRegFee(reqBody);
    if (error) {
      console.log(error);
      return toast.error(error?.data?.message || "Error creating fee", { id: toastId });
    }
    if (data?.status === false) {
      return toast.error(data?.message || "Error creating fee", { id: toastId });
    }
    resetForm();
    return toast.success(data?.message || "Fee created successfully", { id: toastId });
  };
  return (
    <div className="mt-3">
      <Formik
        initialValues={{ name: "", fee_category_id: "", amount: "" }}
        onSubmit={addNewRegFee}
      >
        <Form>
          <CardComp
            cardBodyClassName={"row py-0 gx-5 gy-4"}
            cardClassName={"border-0 rounded-10 px-lg-4 mb-4 pt-4 shadow3"}
          >
            <div className="col-12 mb-2">
              <h5 className="fw-bold mb-1 text-black1">
                Fee Information
              </h5>
              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Enter the details for the new member registration fee
              </p>
            </div>
            
            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaFileInvoiceDollar className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Name
                </label>
                <TextInputComp
                  placeholder={"e.g., Registration Fee, Form Fee"}
                  name="name"
                  required
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaTag className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Category
                  <span className="text-danger ms-1">*</span>
                </label>
                <FormikSelectComp
                  fieldName={"fee_category_id"}
                  selectText="Select Fee Category"
                  isRequired={true}
                  options={[
                    ...feeCategories.map((item) => ({
                      label: item.name,
                      value: item.id,
                    })),
                  ]}
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaDollarSign className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Amount
                </label>
                <MoneyInputComp
                  placeholder={"Enter amount (e.g., 10,000.00)"}
                  name="amount"
                  desc="Leave empty if the fee amount varies or is not fixed"
                />
              </div>
            </div>
          </CardComp>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <ButtonComp
              btnText={"Create Fee"}
              type={"submit"}
              btnClassName={
                "bg-primary1 py-2 px-5 fw-bold text-white border-0 rounded"
              }
              style={{ minWidth: "200px" }}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
}
